import axios from 'axios';
export const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};
export const signUpForNewsletter = async (email, listId = '40d6e4659e', onSuccess, onError) => {
    const u = '83b040af7bf23cbfec2452c69';
    const url = `https://supercluster.us19.list-manage.com/subscribe/post-json?u=${u}&id=${listId}&EMAIL=${encodeURIComponent(email)}`;
    try {
        const res = await axios.get(url, {
            headers: { 'Content-Type': 'application/json' }
        });
        if (res.data.result === 'success') {
            onSuccess();
        }
        else {
            onError(res.data.msg.includes('is already subscribed to list'));
        }
    }
    catch (error) {
        console.log('Fetch error', error);
        return undefined;
    }
};
//# sourceMappingURL=newsletter.js.map